import { Link } from "react-router-dom";
import ProductUnitEditor from "./ProductUnitEditor";

// All purchase-unit definitions of a product (BOX / EACH / …), one card each, edited and confirmed independently.
export default function UnitDefinitions({ product, billedUnits, onSaved }) {
  const defs = product.unit_definitions_view?.length ? product.unit_definitions_view : [null];
  const pending = defs.filter((d) => d && d.status !== "confirmed").length;
  return (
    <div className="mt-3 max-w-2xl" data-testid="unit-definitions">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Packaging per purchase unit <span className="font-mono normal-case tracking-normal text-slate-400">· {product.product_code || "no code"}</span></p>
        {pending > 0 && <Link to="/packaging-review" className="text-[11px] text-amber-800 underline" data-testid="unit-definitions-pending">{pending} not confirmed yet</Link>}
      </div>
      <div className="grid gap-2 sm:grid-cols-2">
        {defs.map((d) => <ProductUnitEditor key={(d?.lane || "unit") + (d?.unit || "") + (d?.status || "")} product={product} definition={d} billedUnits={billedUnits} onSaved={onSaved} />)}
      </div>
      {defs.length > 1 && <p className="mt-1.5 text-[11px] text-slate-500" data-testid="unit-definitions-hint">Each purchase unit keeps its own packaging and its own prices — {defs.find((d) => d && d.primary)?.label || product.unit || "BOX"} and {defs.find((d) => d && !d.primary)?.label || "EACH"} are never mixed in comparisons, charts or New Order.</p>}
    </div>
  );
}
